module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.9011/img/screenshot-og.png"